document.addEventListener('DOMContentLoaded',()=>{document.querySelectorAll('a[href^="#"]').forEach(a=>a.addEventListener('click',e=>{const t=document.querySelector(a.getAttribute('href'));if(t){e.preventDefault();t.scrollIntoView({behavior:'smooth'});}}));});
document.addEventListener('change', function(event) {
  const input = event.target;

  if (!input.matches('input[name="updates[]"]')) return;

  const form = input.closest('form');

  if (form) {
    if (form.requestSubmit) {
      form.requestSubmit();
    } else {
      form.submit();
    }
  }
});
